export const manifest = {
  screens: {
    scr_xeue29: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_u2mozv: { name: "Contact Us", route: "/contact", position: {"x":1560,"y":220} },
  },
  sections: {
    sec_pwbxar: { name: "Primary Navigation", x: 0, y: 0, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_pwbxar", children: [
      { kind: "screen", id: "scr_xeue29" },
      { kind: "screen", id: "scr_u2mozv" },
    ] },
  ],
}
